export const GET_ME = '/users/me/';
export const NOTIFICATIONS = '/users/release-notes/';
export const NOTIFICATIONS_READ_ALL = '/users/release-notes/read-all/';

export const FILTER_OPTIONS = '/improve/filter-options/';
export const TEMPLATES = '/templates/';
export const FRAMWORKDS = '/frameworks/';
export const IMPROVE = '/improve/';
export const DOCS = '/convert-html-content-as-gdoc';

export const PROMPT_BUILDER = '';
export const JOB_ORDERS = '/v2/job-orders';
export const JOB_ORDERS_FALLBACK = '/v1/job-orders';

export const improveContentLike = (improve_request_id: string, id: string) =>
    `/improve/${improve_request_id}/iterations/${id}/like/`;

export const improveContentInteract = (improve_request_id: string, id: string) =>
    `/improve/${improve_request_id}/iterations/${id}/interact/`;

export const improveContentDislike = (improve_request_id: string, id: string) =>
    `/improve/${improve_request_id}/iterations/${id}/dislike/`;

export const getDisclaimer = (improve_request_id: string, id: string) =>
    `/improve/${improve_request_id}/iterations/${id}/disclaimer/`;
